export function SvgLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={168}
      height={28}
      fill="none"
      viewBox="0 0 168 28"
      {...props}
    >
      <mask
        id="ra"
        width={26}
        height={28}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path
          fill="#2A54FC"
          fillRule="evenodd"
          d="m20.193 9.193-5.112-2.8a1.725 1.725 0 0 1-.793-1.104 1.715 1.715 0 0 1 .257-1.333c.536-.766 1.592-.82 2.208-.435l5.89 3.294a2.185 2.185 0 0 1 1.108 1.892v4.89a2.174 2.174 0 0 1-1.115 1.896l-7.461 4.217c-1.124.634-2.524-.164-2.524-1.44 0-.591.32-1.138.841-1.435l6.704-3.83a.463.463 0 0 0 .235-.4v-3.01c0-.165-.09-.319-.238-.402ZM9.656 14.78v7.6c0 .165.089.318.234.4l2.728 1.573a.477.477 0 0 0 .473.002l5.114-2.845c.785-.405 1.731-.18 2.226.506.495.686.373 1.824-.566 2.325l-5.903 3.3a2.248 2.248 0 0 1-2.217.003l-4.391-2.489a2.186 2.186 0 0 1-1.113-1.894v-8.481c0-1.295 1.423-2.104 2.562-1.456.529.3.853.856.853 1.456Zm3.756-2.22L6.84 8.723a.476.476 0 0 0-.475-.003l-2.786 1.582a.463.463 0 0 0-.235.402v6.042c0 .928-.836 1.525-1.651 1.525C.878 18.27 0 17.673 0 16.746V9.809C0 9.025.427 8.3 1.118 7.911L5.5 5.447a2.248 2.248 0 0 1 2.208.004l7.423 4.212a1.671 1.671 0 0 1 .852 1.452 1.661 1.661 0 0 1-.85 1.453 1.724 1.724 0 0 1-1.72-.01Z"
          clipRule="evenodd"
        />
        <path
          fill="#2A54FC"
          d="M0 21.724v-.078c0-1.16.926-2.102 2.069-2.102 1.143 0 2.069.941 2.069 2.102v.078c0 1.16-.926 2.102-2.069 2.102-1.143 0-2.069-.941-2.069-2.1v-.002ZM21.251 20.1v-.078c0-1.16.927-2.101 2.07-2.101 1.142 0 2.068.94 2.068 2.101v.078c0 1.16-.926 2.101-2.069 2.101-1.142 0-2.069-.94-2.069-2.101ZM9.586 2.179V2.1C9.586.941 10.512 0 11.655 0c1.142 0 2.069.94 2.069 2.101v.078c0 1.16-.927 2.101-2.07 2.101-1.142 0-2.068-.94-2.068-2.101Z"
        />
      </mask>
      <g mask="url(#ra)">
        <g clipPath="url(#rb)">
          <path fill="#0A0926" d="M-8.918-3.489h43.225v34.24H-8.918z" />
          <g
            filter="url(#rc)"
            style={{
              mixBlendMode: "screen",
            }}
          >
            <circle
              cx={-1.727}
              cy={2.521}
              r={15.352}
              fill="#65D9F2"
              transform="rotate(-13.027 -1.727 2.521)"
            />
          </g>
          <g
            filter="url(#rd)"
            style={{
              mixBlendMode: "screen",
            }}
          >
            <circle
              cx={21.623}
              cy={29.455}
              r={23.86}
              fill="#EB4E39"
              transform="rotate(-13.027 21.623 29.455)"
            />
          </g>
          <g
            filter="url(#re)"
            style={{
              mixBlendMode: "screen",
            }}
          >
            <circle
              cx={20.07}
              cy={6.329}
              r={18.219}
              fill="#F90"
              transform="rotate(-13.027 20.07 6.329)"
            />
          </g>
        </g>
        <path
          stroke="#E6E6E6"
          strokeWidth={0.243}
          d="M-8.797-3.368h42.982v33.997H-8.797z"
        />
      </g>
      <path
        fill="#0A0926"
        data-intractive-letters
        d="M35.045 25.523V9.146h4.161v16.377h-4.16Zm2.08-18.292c-.748 0-1.386-.242-1.914-.727-.507-.484-.76-1.122-.76-1.915 0-.792.253-1.43.76-1.915.528-.484 1.166-.726 1.915-.726.77 0 1.409.242 1.915.726s.76 1.123.76 1.915c0 .793-.254 1.431-.76 1.915-.506.485-1.145.727-1.915.727ZM41.835 25.523V9.146h4.094v2.146h.595c.264-.572.76-1.111 1.486-1.618.726-.528 1.827-.792 3.302-.792 1.276 0 2.388.297 3.335.891a5.795 5.795 0 0 1 2.245 2.41c.528 1.013.792 2.202.792 3.567v9.773h-4.16V16.08c0-1.233-.308-2.157-.925-2.774-.594-.616-1.452-.924-2.575-.924-1.277 0-2.267.43-2.972 1.288-.704.836-1.056 2.014-1.056 3.533v8.32h-4.16ZM66.023 25.523c-1.079 0-1.96-.33-2.641-.99-.66-.683-.991-1.585-.991-2.708V12.58h-4.094V9.146h4.094V4.06h4.16v5.085h4.491v3.434h-4.49v8.519c0 .66.307.99.924.99h3.17v3.434h-4.623ZM72.827 25.523V9.146h4.094v1.849h.594c.243-.66.639-1.145 1.19-1.453.572-.308 1.232-.462 1.98-.462h1.982v3.698h-2.048c-1.056 0-1.926.286-2.608.858-.683.55-1.024 1.41-1.024 2.576v9.311h-4.16ZM88.635 25.986c-1.166 0-2.212-.198-3.136-.595-.925-.418-1.662-1.012-2.213-1.783-.528-.792-.792-1.75-.792-2.872 0-1.123.264-2.059.792-2.807.55-.77 1.299-1.343 2.245-1.717.97-.396 2.07-.594 3.302-.594h4.491v-.925c0-.77-.242-1.398-.726-1.882-.485-.506-1.255-.76-2.312-.76-1.034 0-1.805.243-2.311.727-.506.462-.837 1.068-.99 1.816l-3.83-1.288a6.616 6.616 0 0 1 1.254-2.278c.594-.704 1.376-1.266 2.344-1.684.99-.44 2.19-.66 3.6-.66 2.157 0 3.863.539 5.117 1.618 1.255 1.078 1.882 2.641 1.882 4.688V21.1c0 .66.309.99.925.99h1.32v3.434h-2.773c-.814 0-1.486-.198-2.014-.594a1.883 1.883 0 0 1-.793-1.585v-.033h-.627c-.088.264-.286.616-.594 1.057-.308.418-.793.792-1.453 1.122-.66.33-1.563.496-2.708.496Zm.727-3.368c1.166 0 2.113-.32 2.84-.958.748-.66 1.122-1.53 1.122-2.608v-.33h-4.193c-.77 0-1.376.165-1.817.495-.44.33-.66.792-.66 1.387 0 .594.231 1.078.694 1.452.462.375 1.133.562 2.014.562ZM108.03 25.986c-1.585 0-3.027-.33-4.326-.99a7.482 7.482 0 0 1-3.038-2.873c-.748-1.255-1.123-2.774-1.123-4.557v-.462c0-1.784.375-3.302 1.123-4.557a7.482 7.482 0 0 1 3.038-2.873c1.299-.66 2.741-.99 4.326-.99 1.562 0 2.905.275 4.028.825 1.123.55 2.025 1.31 2.707 2.278a7.616 7.616 0 0 1 1.387 3.236l-4.028.859a4.746 4.746 0 0 0-.594-1.783 3.31 3.31 0 0 0-1.321-1.255c-.551-.308-1.244-.462-2.08-.462-.837 0-1.596.187-2.279.561-.66.352-1.188.892-1.585 1.618-.374.704-.561 1.574-.561 2.609v.33c0 1.034.187 1.915.561 2.641.397.705.925 1.244 1.585 1.618.683.352 1.442.529 2.279.529 1.254 0 2.201-.32 2.839-.958.661-.66 1.079-1.519 1.255-2.575l4.028.957a9.053 9.053 0 0 1-1.486 3.203c-.682.947-1.584 1.695-2.707 2.245-1.123.55-2.466.826-4.028.826ZM123.428 25.523c-1.079 0-1.96-.33-2.642-.99-.66-.683-.991-1.585-.991-2.708V12.58h-4.094V9.146h4.094V4.06h4.161v5.085h4.491v3.434h-4.491v8.519c0 .66.308.99.924.99h3.17v3.434h-4.622ZM130.231 25.523V9.146h4.161v16.377h-4.161ZM140.455 25.523l-5.217-16.377h4.424l3.798 13.34h.594l3.797-13.34h4.425l-5.217 16.377h-6.604ZM160.108 25.986c-1.629 0-3.071-.341-4.325-1.024a7.604 7.604 0 0 1-2.906-2.939c-.682-1.276-1.024-2.773-1.024-4.49v-.396c0-1.717.342-3.203 1.024-4.458.682-1.277 1.64-2.256 2.873-2.939 1.232-.704 2.663-1.056 4.292-1.056 1.607 0 3.005.363 4.194 1.09 1.188.704 2.113 1.694 2.773 2.971.661 1.255.991 2.719.991 4.392v1.42h-11.92c.044 1.122.462 2.036 1.255 2.74.792.704 1.761 1.057 2.905 1.057 1.167 0 2.025-.253 2.576-.76a5.345 5.345 0 0 0 1.254-1.684l3.401 1.783c-.308.572-.759 1.2-1.353 1.882-.573.66-1.343 1.233-2.312 1.717-.968.463-2.201.694-3.698.694Zm-3.995-10.533h7.66c-.088-.947-.473-1.706-1.155-2.279-.661-.572-1.53-.858-2.609-.858-1.123 0-2.014.286-2.674.858-.661.573-1.068 1.332-1.222 2.279Z"
      />
      <defs>
        <filter
          id="rc"
          width={61.175}
          height={61.176}
          x={-32.314}
          y={-28.067}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_1023_7693"
            stdDeviation={7.616}
          />
        </filter>
        <filter
          id="rd"
          width={78.195}
          height={78.196}
          x={-17.474}
          y={-9.643}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_1023_7693"
            stdDeviation={7.616}
          />
        </filter>
        <filter
          id="re"
          width={66.91}
          height={66.911}
          x={-13.385}
          y={-27.127}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_1023_7693"
            stdDeviation={7.616}
          />
        </filter>
        <clipPath id="rb">
          <path fill="#fff" d="M-8.918-3.489h43.225v34.24H-8.918z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgLogo;
